import type { TimeZoneData } from 'ProviderInformation-Types';

type TimeZoneDataProps = {
  timeZoneData?: TimeZoneData | null;
  isIndirectContract?: boolean;
};

const DIRECT_PROVIDER_TIMEZONE_ID = '(JST)';

export function getTimeZoneString(
  timeZoneData?: TimeZoneData | null,
  isIndirectContract?: boolean,
) {
  if (!isIndirectContract) {
    return DIRECT_PROVIDER_TIMEZONE_ID;
  }
  return `(${timeZoneData?.providerZoneId}, ${timeZoneData?.standardZoneId}${timeZoneData?.offset})`;
}

function TimeZoneInfo({ timeZoneData, isIndirectContract }: TimeZoneDataProps) {
  return <>{getTimeZoneString(timeZoneData, isIndirectContract)}</>;
}

export default TimeZoneInfo;
